
export class RapportsRemboursSLCTSZ {
    vague_slc:any;
    date_slc  :any;
    //dat_fin_rap :any;
    nbr_rec  :any;
    montant_rec :any;
    nbr_irrec :any;
    montant_irrec:any;
    fichier_slc  :any
    etat_slc :any;
    responsable:any;
    id_rembourse_slc:any
    nbr_anatt : any;
    montant_anatt:any;

    constructor( id_rembourse_slc:any){
      
    }
}
